import { BadgeCheck, Eye, FileSearch, ShieldAlert } from 'lucide-react';

const iconMap = {
  collect: FileSearch,
  verify: BadgeCheck,
  moderate: ShieldAlert,
  publish: Eye,
};

const ReviewQualityFramework = ({ steps = [] }) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {steps.map((step, index) => {
        const Icon = iconMap[step.iconKey] || BadgeCheck;

        return (
          <article
            key={step.title}
            className={`home-reveal flex h-full flex-col items-center justify-center rounded-2xl border border-slate-200 bg-white p-5 text-center shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-cyan-200 hover:shadow-md ${
              index % 2 === 1 ? 'home-reveal-delay' : ''
            }`}
          >
            <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-xl bg-cyan-50 text-cyan-700">
              <Icon size={18} />
            </div>

            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">{step.label}</p>
            <h3 className="text-base font-semibold text-slate-900">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">{step.description}</p>
          </article>
        );
      })}
    </div>
  );
};

export default ReviewQualityFramework;
